<template>
	<modal
		class="closed-by-staff-modal"
		:dark-theme="darkTheme"
		:is-loading="isTicketingRedirectLoading"
		first-button-text="Ok"
		:first-button-action="goToMenu"
	>
		<div class="staff-close-message">
			<span class="staff-close-label">Your tab at</span>
			<span class="staff-close-highlight">{{ venueInfo.name }}</span>
			<span class="staff-close-label">was closed by</span>
			<span class="staff-close-highlight">{{ employeeName }}</span>
		</div>
	</modal>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import eventApi from '@/api/events'
import storage from '@/utils/storage'
import routerMixin from '@/mixins/routerMixin'
import Modal from '@/components/modals/Modal.vue'

export default {
	name: 'ClosedByStaffCheckoutModal',

	mixins: [routerMixin],

	components: { Modal },

	props: {
		darkTheme: {
			type: Boolean,
			default: false
		},
		employeeName: {
			type: String,
			default: 'Staff'
		}
	},

	data() {
		return {
			isTicketingRedirectLoading: false
		}
	},

	computed: {
		...mapState('cart', {
			cartId: 'id',
			eventTicketId: 'eventTicketId'
		}),
		...mapState('venue', ['venueInfo']),
		...mapGetters('cart', ['isTabOpenedByRedemption'])
	},

	methods: {
		...mapActions('cart', ['setReceiptShown']),

		async goToMenu() {
			if (this.isTicketingRedirectLoading) {
				return
			}

			await this.setReceiptShown(this.cartId)
			storage.removeFromStorage('cartId')

			if (this.isTabOpenedByRedemption) {
				await this.redirectToTicketingDestination()

				return
			}

			await this.goToProducts()
			this.close()
		},

		async redirectToTicketingDestination() {
			if (!this.eventTicketId || !this.venueInfo.id) {
				this.goToTicketingEvents()

				return
			}

			try {
				this.isTicketingRedirectLoading = true

				const response = await eventApi.getEventTicket({
					eventTicketId: this.eventTicketId,
					venueId: this.venueInfo.id
				})
				const eventPurchaseOrderId =
					response?.data?.eventPurchaseOrderId ||
					response?.data?.eventPurchaseOrder?.id

				if (eventPurchaseOrderId) {
					this.goToTicketingOrder(eventPurchaseOrderId)

					return
				}

				this.goToTicketingEvents()
			} catch (e) {
				console.error(e)
				this.goToTicketingEvents()
			} finally {
				this.isTicketingRedirectLoading = false
			}
		},

		close() {
			this.$emit('close')
		}
	}
}
</script>

<style scoped lang="scss">
.closed-by-staff-modal {
	.staff-close-message {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin: 0 0 20px;
		text-align: center;
	}

	.staff-close-label {
		display: block;
		margin-bottom: 10px;
		font-size: 16px;
		line-height: 1.35;
		opacity: 0.8;
	}

	.staff-close-highlight {
		display: block;
		margin-bottom: 7px;
		font-size: 18px;
		line-height: 1.35;
		font-weight: 700;
	}
}
</style>
